import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";

import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import StyledTableRow from "app/Components/Tables/StyledTableRow";
import StyledTableCell from "app/Components/Tables/StyledTableCell";
import Paper from "@mui/material/Paper";

import { CSVLink, CSVDownload } from "react-csv";

import GameSessionsTableHeader from "./GameSessionsHeader";

const useStyles = makeStyles({
  Button: {
    width: "90%",
    color: "white",
    backgroundColor: "teal",
    padding: "12px",
    border: "none",
    cursor: "pointer",
    textDecoration: "none",
  },
});

const RenderPlayTime = (endTime: number, startTime: number) => {
  const MillisecondsPerSec = 1000;
  const SecsPerMin = 60;

  const playTimeinSecs = (endTime - startTime) / MillisecondsPerSec;
  const playTimeInMinutes =
    (endTime - startTime) / (SecsPerMin * MillisecondsPerSec);
  const seconds = Math.floor(playTimeinSecs % 60);
  const hours = Math.floor(playTimeInMinutes / 60);
  const minutes = Math.floor(playTimeInMinutes % 60);

  return (
    <div>
      {hours}hrs {minutes}mins {seconds}s
    </div>
  );
};

interface GameSession {
  id: string;
  startedAt: number;
  endedAt: number;
  gameName: string;
}

const renderTableBody = (gameSessions: GameSession[]) => (
  <TableBody>
    {gameSessions.map((sale) => {
      const { id, startedAt, endedAt, gameName } = sale;
      const startTimeString = new Date(startedAt).toString().split("GMT")[0];
      const endTimeString = new Date(endedAt).toString().split("GMT")[0];

      return (
        <StyledTableRow key={id}>
          <StyledTableCell align="center">{gameName}</StyledTableCell>
          <StyledTableCell align="center">{startTimeString}</StyledTableCell>
          <StyledTableCell align="center">{endTimeString}</StyledTableCell>
          <StyledTableCell align="center">
            {RenderPlayTime(endedAt, startedAt)}
          </StyledTableCell>
        </StyledTableRow>
      );
    })}
  </TableBody>
);

const GameSessionsTable = () => {
  const classes = useStyles();
  const filteredGameSessions = useSelector(
    (state: any) => state.sessions.filteredGameSessions,
  );
  const fetched = useSelector((state: any) => state.sessions.fetchedGameSessions);

  return (
    <div>
      {fetched ? (
        <>
          <CSVLink
            data={filteredGameSessions}
            filename="GameSessions.csv"
            className={classes.Button}
          >
            Download Game Sessions
          </CSVLink>
          <br />
          <br />

          <TableContainer component={Paper}>
            {filteredGameSessions.length === 0 ? (
              <>No Sales Found</>
            ) : (
              <Table aria-label="customized table">
                {GameSessionsTableHeader()}
                {renderTableBody(filteredGameSessions)}
              </Table>
            )}
          </TableContainer>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default GameSessionsTable;
